import { useEffect, useState } from 'react'
import { isEmpty } from 'lodash'
import { Link } from 'react-router-dom'
// import { useSnackbar } from 'notistack'

import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Grid,
  useTheme,
} from '@mui/material'
import {
  Edit as EditIcon,
  Link as LinkIcon,
  PersonRemove as PersonRemoveIcon,
} from '@mui/icons-material'

// import PrintIcon from '@mui/icons-material/Print';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined';
import ReceiptTwoToneIcon from '@mui/icons-material/ReceiptTwoTone';
import SystemUpdateAltTwoToneIcon from '@mui/icons-material/SystemUpdateAltTwoTone';
import DeleteOutlineTwoToneIcon from '@mui/icons-material/DeleteOutlineTwoTone';
import StarsRoundedIcon from '@mui/icons-material/StarsRounded';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import HowToVoteIcon from '@mui/icons-material/HowToVote';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import OutboxTwoToneIcon from '@mui/icons-material/OutboxTwoTone';
import {
  ConfirmationDialog,
  DialogTeleport,
  SurveyOpenAndCloseDateDialog,
  SurveyReminderNotificationsDialog,
  ReminderNotificationsIcon,
  SurveyPreviewDialog,
} from 'components'
import { ManageSurvey, Surveys } from 'pages'
import { SurveyStatus } from 'enums/survey'
import { ROUTES_PATHS } from 'core/routes'
import { useUser } from 'contexts/UserContext'
import { initialDialog } from 'constants/dialog'
import { t } from 'i18n'
import dayjs from 'dayjs'
import CreateRandomParticipationsDialog from '../CreateRandomParticipationsDialog/CreateRandomParticipationsDialog'
import { userIsCompanyAdmin } from 'utils/user'

export default function SurveyOverviewActions({
  surveys,
  selectedSurvey,
  company,
  confirmDeleteDialogOpen,
  setConfirmDeleteDialogOpen,
  setConfirmCloseDialogOpen,
  setConfirmLaunchSurveyDialogOpen,
  setExtendSurveyDialogOpen,
  setInviteEmployeeDialogOpen,
  setRemoveEmployeesDialogOpen,
  getSurveyOverview,
  fetchSurveys,
  addSurveyToCart,
  addSurveyToCartIsLoading,
  createRandomParticipationsMutation,
  toggleSurveyReportLevelMutation,
  uninvitedUsers,
  launchSurveyMutation,
  deleteSurveyMutation,
  preview,
  getSurveyPreview,
  sharePreviewLinkMutation,
  previewLinkStatus,
  hide = false
}: any) {
  const theme = useTheme()
  const { user } = useUser()!

  const isSparckAdmin = !!user?.sparck_administrator
  const isCompanyAdmin = userIsCompanyAdmin(user)
  const canManageOpenSurveyUsers = isSparckAdmin || isCompanyAdmin

  // const { enqueueSnackbar } = useSnackbar()
  const [dialogManageSurvey, setDialogManageSurvey] = useState(initialDialog)
  const [closeDateDialogOpen, setCloseDateDialogOpen] = useState(false)
  const [confirmLaunchSurveyDialog, setConfirmLaunchSurveyDialog] = useState(false);
  const [surveyCloseDate, setSurveyCloseDate] = useState(
    selectedSurvey?.close_at,
  )
  const [previewDialog, setPreviewDialog] = useState(initialDialog)
  const [reminderNotificationsDialogOpen, setReminderNotificationsDialogOpen] =
    useState(false)
  const [randomParticipationsDialogOpen, setRandomParticipationsDialogOpen] =
    useState(false)

  const companyHasActiveSurvey = surveys.find(
    survey => survey.status !== SurveyStatus.Close,
  )
  const remindersAvailable =
    selectedSurvey?.status === SurveyStatus.Open ||
    selectedSurvey?.status === SurveyStatus.Close

  useEffect(() => {
    getSurveyPreview()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Mobile: each button grows to fill a shared basis so a lone button
  // stretches full width and two share a row evenly - matches the
  // vertical progress timeline it sits below. Desktop: buttons keep
  // their own natural content width, centered as a group.
  const compactActionBoxSx = {
    flex: { xs: '1 1 220px', sm: '0 1 auto' },
    maxWidth: { xs: 340, sm: 'none' },
  }
  const compactActionButtonSx = {
    width: { xs: '100%', sm: 'auto' },
  }

  return (
    <>
      {!hide ? <Grid container justifyContent='flex-end'>
        <Grid item xs={12}>
          {!companyHasActiveSurvey && (
            <>
              <Box mb={1} data-cy='clone_survey'>
                <Button
                  variant='outlined'
                  color='primary'
                  fullWidth
                  onClick={() =>
                    setDialogManageSurvey({
                      isOpen: true,
                      data: { ...selectedSurvey, isClone: true },
                    })
                  }
                >
                  Clone Survey
                </Button>
              </Box>
            </>
          )}

          {(selectedSurvey.status === SurveyStatus.Scheduled ||      //{  2nd condition}
            selectedSurvey.status === SurveyStatus.AwaitingManualOpening) && (
              <>
                <Grid item xs='auto' justifyContent={'flex-end'}>
                  <Box mb={1} data-cy='launch_survey'>
                    <Button
                      variant='contained'
                      color='primary'
                      fullWidth
                      onClick={() => setCloseDateDialogOpen(true)}
                    >
                      {t('surveyOverview.launchSurvey')}
                    </Button>
                  </Box>
                </Grid>
                <Grid item xs='auto' justifyContent={'flex-end'}>
                  <Box mb={1} data-cy='preview_survey'>
                    <Button
                      variant='contained'
                      color='primary'
                      fullWidth
                      onClick={async () => {
                        await getSurveyPreview()

                        setPreviewDialog({
                          isOpen: true,
                          data: {
                            ...preview.survey,
                            answers: [],
                          },
                        })
                      }}
                    >
                      Preview Survey
                    </Button>
                  </Box>
                </Grid>
                <Box mb={1} data-cy='editSurvey'>
                  <Button
                    variant='contained'
                    color='primary'
                    fullWidth
                    onClick={() =>
                      setDialogManageSurvey({
                        isOpen: true,
                        data: selectedSurvey,
                      })
                    }
                  >
                    {t('surveyOverview.editSurvey')}
                  </Button>
                </Box>
              </>
            )}

          {remindersAvailable && (
            <Box mb={1}>
              <Button
                variant='outlined'
                color='primary'
                fullWidth
                startIcon={<ReminderNotificationsIcon />}
                onClick={() => setReminderNotificationsDialogOpen(true)}
              >
                Config reminder notifications
              </Button>
            </Box>
          )}

          {selectedSurvey.status === SurveyStatus.Open && (
            <>
              <Box mb={1}>
                <Button
                  variant='outlined'
                  color='primary'
                  fullWidth
                  onClick={() => setExtendSurveyDialogOpen(true)}
                >
                  {t('surveyOverview.extendSurvey')}
                </Button>
              </Box>
              <Box mb={1}>
                <Button
                  data-cy='close_survey'
                  variant='outlined'
                  color='error'
                  fullWidth
                  onClick={() => setConfirmCloseDialogOpen(true)}
                >
                  {t('surveyOverview.closeSurvey')}
                </Button>
              </Box>
              {canManageOpenSurveyUsers && (
                <Box mb={1}>
                  <Button
                    data-cy='remove_survey_participants'
                    variant='outlined'
                    color='primary'
                    fullWidth
                    onClick={() => setRemoveEmployeesDialogOpen(true)}
                  >
                    {t('surveyOverview.removeEmployees')}
                  </Button>
                </Box>
              )}
              {isSparckAdmin && (
                <Box mb={1}>
                  <Button
                    variant='contained'
                    color='primary'
                    fullWidth
                    onClick={() => setRandomParticipationsDialogOpen(true)}
                  >
                    {t('surveyOverview.createRandomParticipations')}
                  </Button>
                </Box>
              )}
            </>
          )}

          {selectedSurvey.status === SurveyStatus.Open && (
            <>
              <Box mb={1}>
                <Button
                  variant='outlined'
                  color='primary'
                  fullWidth
                  onClick={() => setExtendSurveyDialogOpen(true)}
                >
                  {t('surveyOverview.extendSurvey')}
                </Button>
              </Box>
              <Box mb={1}>
                <Button
                  data-cy='close_survey'
                  variant='outlined'
                  color='error'
                  fullWidth
                  onClick={() => setConfirmCloseDialogOpen(true)}
                >
                  {t('surveyOverview.closeSurvey')}
                </Button>
              </Box>
              {canManageOpenSurveyUsers && (
                <Box mb={1}>
                  <Button
                    data-cy='remove_survey_participants'
                    variant='outlined'
                    color='primary'
                    fullWidth
                    onClick={() => setRemoveEmployeesDialogOpen(true)}
                  >
                    {t('surveyOverview.removeEmployees')}
                  </Button>
                </Box>
              )}
              {isSparckAdmin && (
                <Box mb={1}>
                  <Button
                    variant='contained'
                    color='primary'
                    fullWidth
                    onClick={() => setRandomParticipationsDialogOpen(true)}
                  >
                    {t('surveyOverview.createRandomParticipations')}
                  </Button>
                </Box>
              )}
            </>
          )}

          {selectedSurvey.status === SurveyStatus.Close &&                    //3rd condition
            selectedSurvey.report_level === 'free' && (
              <>
                {isSparckAdmin && (
                  <Box mb={1}>
                    <Button
                      variant='outlined'
                      fullWidth
                      color='primary'
                      onClick={() =>
                        toggleSurveyReportLevelMutation.mutate({
                          id: selectedSurvey.id,
                        })
                      }
                    >
                      {t('surveyOverview.applyUpgrade')}
                    </Button>
                  </Box>
                )}

                <Box mb={1}>
                  <Button
                    variant='contained'
                    fullWidth
                    onClick={addSurveyToCart}
                    disabled={addSurveyToCartIsLoading}
                  >
                    {addSurveyToCartIsLoading ? (
                      <CircularProgress size={24} color='secondary' />
                    ) : (
                      t('report.upgradeReport')
                    )}
                  </Button>
                </Box>
              </>
            )}

          {selectedSurvey.status === SurveyStatus.Close &&                 //4th condition
            selectedSurvey.report_level === 'free' && (
              <Box mb={1}>
                <Link
                  to={`${ROUTES_PATHS.beheardReport}?id=${selectedSurvey.id}&full_report=0`}
                >
                  <Button
                    variant='contained'
                    sx={{
                      background: `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.error.light})`,
                    }}
                    fullWidth
                    onClick={() => { }}
                  >
                    {t('report.freeReport')}
                  </Button>
                </Link>
              </Box>
            )}

          {selectedSurvey.status === SurveyStatus.Close &&         //5th condition
            selectedSurvey.report_level === 'upgraded' && (
              <>
                {isSparckAdmin && (
                  <Box mb={1}>
                    <Button
                      variant='outlined'
                      color='primary'
                      fullWidth
                      onClick={() =>
                        toggleSurveyReportLevelMutation.mutate({
                          id: selectedSurvey.id,
                        })
                      }
                    >
                      {t('surveyOverview.applyDowngrade')}
                    </Button>
                  </Box>
                )}
                <Box mb={1}>
                  <Link
                    to={`${ROUTES_PATHS.beheardReport}?id=${selectedSurvey.id}&full_report=1`}
                  >
                    <Button
                      variant='contained'
                      sx={{
                        background: `linear-gradient(135deg, ${theme.palette.secondary.main}, ${theme.palette.error.light})`,
                      }}
                      fullWidth
                      onClick={() => { }}
                    >
                      {t('report.premiumReport')}
                    </Button>
                  </Link>
                </Box>
              </>
            )}

          {!isEmpty(uninvitedUsers) &&
            selectedSurvey.status !== SurveyStatus.Close && (
              <Box mb={1} data-cy='inviteEmployees'>
                <Button
                  variant='outlined'
                  color='primary'
                  fullWidth
                  onClick={() =>
                    setInviteEmployeeDialogOpen({ isOpen: true, data: null })
                  }
                >
                  {t('surveyOverview.inviteEmployees')}
                </Button>
              </Box>
            )}

          {selectedSurvey.status !== SurveyStatus.Open &&            // 6th condition
            selectedSurvey.report_level !== 'upgraded' && (
              <Box mb={1} data-cy='deleteSurvey'>
                <Button
                  variant='outlined'
                  color='error'
                  fullWidth
                  onClick={() => setConfirmDeleteDialogOpen(true)}
                >
                  {t('surveyOverview.deleteSurvey')}
                </Button>
              </Box>
            )}
        </Grid>
      </Grid> :
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
          }}
        >
          {/* share Button */}
          {/* {selectedSurvey.status === SurveyStatus.Close &&
            <Box data-cy='clone_survey'>
              <Button
                variant='outlined'
                onClick={() => {
                  `Survey Shared Link has been copied to your clipboard`,
                  navigator.clipboard.writeText(`${window.location.hostname}${ROUTES_PATHS.beheardReport}?id=${selectedSurvey.id}&full_report=1`); enqueueSnackbar(
                    { variant: 'success' },
                  )
                }}
              >
                <ShareIcon />  &nbsp;
                Share
              </Button>
            </Box>
          } */}
          {selectedSurvey.status === SurveyStatus.Close &&
            selectedSurvey.report_level === 'free' && (
              <Box sx={compactActionBoxSx}>
                <Link
                  to={`${ROUTES_PATHS.beheardReport}?id=${selectedSurvey.id}&full_report=0`}
                >
                  <Button
                    variant='outlined'
                    color='primary'
                    sx={compactActionButtonSx}
                    onClick={() => { }}
                  >
                    <BookmarksIcon />  &nbsp;
                    {t('report.freeReport')}
                  </Button>
                </Link>
              </Box>
            )}
          {(selectedSurvey.status === SurveyStatus.Scheduled ||
            selectedSurvey.status === SurveyStatus.AwaitingManualOpening) && (
              <Box sx={compactActionBoxSx} data-cy='launch_survey'>
                <Button
                  style={{ fontSize: '12px' }}
                  variant='outlined'
                  color='primary'
                  sx={compactActionButtonSx}
                  onClick={() => setCloseDateDialogOpen(true)}
                >
                  <OutboxTwoToneIcon />  &nbsp;
                  {t('surveyOverview.launchSurvey')}
                </Button>
              </Box>
            )}

          {/* Print Button */}
          {/* {(selectedSurvey.status === SurveyStatus.Scheduled ||
            selectedSurvey.status === SurveyStatus.Close) && (
              <Box>
                <Link
                  to={`${ROUTES_PATHS.beheardReport}?id=${selectedSurvey.id}&full_report=${selectedSurvey.report_level === 'upgraded' ? 1 : 0}`}
                >
                  <Button
                    variant='outlined'>
                    <PrintIcon />  &nbsp;
                    {t("surveyOverview.printSurvey")}
                  </Button>
                </Link>
              </Box>
            )} */}

          {/* Close button */}
          {remindersAvailable && (
            <Box sx={compactActionBoxSx} data-cy='config_reminder_notifications'>
              <Button
                variant='outlined'
                color='primary'
                sx={{ ...compactActionButtonSx, whiteSpace: 'nowrap' }}
                onClick={() => setReminderNotificationsDialogOpen(true)}
              >
                <ReminderNotificationsIcon /> &nbsp;
                Config reminder notifications
              </Button>
            </Box>
          )}

          {selectedSurvey.status === SurveyStatus.Open && (
            <>
              <Box sx={compactActionBoxSx} data-cy='close_survey'>
                <Button
                  variant='outlined'
                  color='primary'
                  sx={compactActionButtonSx}
                  onClick={() =>
                    setConfirmCloseDialogOpen({
                      isOpen: true,
                      data: { ...selectedSurvey, isClone: true },
                    })
                  }
                >
                  <CancelOutlinedIcon />  &nbsp;
                  {t('surveyOverview.closeSurvey')}
                </Button>
              </Box>
              {isSparckAdmin && (
                <Box sx={compactActionBoxSx} data-cy='create_random_participations'>
                  <Button
                    variant='contained'
                    color='primary'
                    sx={{ ...compactActionButtonSx, whiteSpace: 'nowrap' }}
                    onClick={() => setRandomParticipationsDialogOpen(true)}
                  >
                    <HowToVoteIcon /> &nbsp;
                    {t('surveyOverview.createRandomParticipations')}
                  </Button>
                </Box>
              )}
              {canManageOpenSurveyUsers && (
                <Box sx={compactActionBoxSx} data-cy='remove_survey_participants'>
                  <Button
                    variant='outlined'
                    color='primary'
                    sx={compactActionButtonSx}
                    onClick={() => setRemoveEmployeesDialogOpen(true)}
                  >
                    <PersonRemoveIcon /> &nbsp;
                    {t('surveyOverview.removeEmployees')}
                  </Button>
                </Box>
              )}
              <Box sx={compactActionBoxSx} data-cy='extend_survey'>
                <Button
                  variant='outlined'
                  color='primary'
                  sx={compactActionButtonSx}
                  onClick={() =>
                    setExtendSurveyDialogOpen({
                      isOpen: true,
                      data: { ...selectedSurvey, isClone: true },
                    })
                  }
                >
                  <EventOutlinedIcon />  &nbsp;
                  {t('surveyOverview.extendSurvey')}
                </Button>
              </Box>
            </>
          )}

          {/* Clone Button */}
          {!companyHasActiveSurvey && (
            <Box sx={compactActionBoxSx} data-cy='clone_survey'>
              <Button
                variant='outlined'
                sx={compactActionButtonSx}
                onClick={() =>
                  setDialogManageSurvey({
                    isOpen: true,
                    data: { ...selectedSurvey, isClone: true },
                  })
                }>
                <FileCopyOutlinedIcon />  &nbsp;
                Clone
              </Button>
            </Box>
          )}

          {/* Apply Upgrade Button */}
          {selectedSurvey.status === SurveyStatus.Close &&
            selectedSurvey.report_level === 'free' && (
              <Box sx={compactActionBoxSx}>
                <Button
                  variant='contained'
                  color='secondary'
                  sx={compactActionButtonSx}
                  onClick={addSurveyToCart}
                  disabled={addSurveyToCartIsLoading}
                >
                  {addSurveyToCartIsLoading ? (
                    <CircularProgress size={24} color='secondary' />
                  ) : (
                    <ReceiptTwoToneIcon />
                  )}  &nbsp;
                  {t('report.upgradeReport')}
                </Button>
              </Box>
            )}

          {/* Delete Button */}
          {selectedSurvey.status !== SurveyStatus.Open &&
            selectedSurvey.report_level !== 'upgraded' && (
              <Box sx={compactActionBoxSx} data-cy='deleteSurvey'>
                <Button
                  variant='outlined'
                  sx={compactActionButtonSx}
                  onClick={() => setConfirmDeleteDialogOpen(true)}
                >
                  <DeleteOutlineTwoToneIcon />  &nbsp;
                  {t('surveyOverview.deleteSurvey')}
                </Button>
              </Box>
            )}

          {/* Launch Survey Button */}
          {(selectedSurvey.status === SurveyStatus.Scheduled ||
            selectedSurvey.status === SurveyStatus.AwaitingManualOpening) && (
              <>
                {/* Preview Survey Button */}
                <Box sx={compactActionBoxSx} data-cy='preview_survey'>
                  <Button
                    variant='outlined'
                    sx={compactActionButtonSx}
                    onClick={async () => {
                      await getSurveyPreview()

                      setPreviewDialog({
                        isOpen: true,
                        data: {
                          ...preview.survey,
                          answers: [],
                        },
                      })
                    }}>
                    <ManageSearchIcon />  &nbsp;
                    Preview Survey
                  </Button>
                </Box>

                {/* Edit Survey Button */}
                <Box sx={compactActionBoxSx} data-cy='editSurvey'>
                  <Button
                    variant='outlined'
                    sx={compactActionButtonSx}
                    onClick={() =>
                      setDialogManageSurvey({
                        isOpen: true,
                        data: selectedSurvey,
                      })
                    }
                    color='primary'
                  >
                    <EditIcon />  &nbsp;
                    {t('surveyOverview.editSurvey')}
                  </Button>
                </Box>
              </>
            )}

          {/* Apply DownGrade Button */}
          {selectedSurvey.status === SurveyStatus.Close &&
            selectedSurvey.report_level === 'upgraded' && (
              <>
                {isSparckAdmin && (
                  <Box sx={compactActionBoxSx}>
                    <Button
                      variant='outlined'
                      sx={compactActionButtonSx}
                      onClick={() =>
                        toggleSurveyReportLevelMutation.mutate({
                          id: selectedSurvey.id,
                        })
                      }>
                      <SystemUpdateAltTwoToneIcon />  &nbsp;
                      {t('surveyOverview.applyDowngrade')}
                    </Button>
                  </Box>
                )}

                {/* Premium Report Button */}
                <Box sx={{ ...compactActionBoxSx, flex: { xs: '1 1 100%', sm: '0 1 auto' } }}>
                  <Link
                    to={`${ROUTES_PATHS.beheardReport}?id=${selectedSurvey.id}&full_report=1`}
                  >
                    <Button
                      variant='contained'
                      color='secondary'
                      sx={compactActionButtonSx}
                    >
                      <StarsRoundedIcon />  &nbsp;
                      {t('report.premiumReport')}
                    </Button>
                  </Link>
                </Box>
              </>
            )}
        </Box>
      }

      {
        dialogManageSurvey.isOpen &&
        <DialogTeleport
          dialogTitle=''
          dialogAction={null}
          dialogSize='md'
          dialogOpen={!!dialogManageSurvey.isOpen}
          handleDialogClose={() =>
            setDialogManageSurvey({ isOpen: false, data: null })

          }
          isFullWidth
        >
          <ManageSurvey
            dialog={dialogManageSurvey}
            closeDialog={() => setDialogManageSurvey(initialDialog)}
            fetchSurveyOverview={getSurveyOverview}
            fetchSurveys={fetchSurveys}
          />
        </DialogTeleport>
      }

      {isSparckAdmin && (
        <CreateRandomParticipationsDialog
          open={randomParticipationsDialogOpen}
        onClose={() => setRandomParticipationsDialogOpen(false)}
        company={company}
        survey={selectedSurvey}
        createRandomParticipationsMutation={createRandomParticipationsMutation}
        />
      )}

      <SurveyOpenAndCloseDateDialog
        title='When do you want your survey to close?'
        isDialogOpen={closeDateDialogOpen}
        setIsDialogOpen={setCloseDateDialogOpen}
        survey={selectedSurvey}
        action={date => {
          const formattedDate = dayjs(date).format('YYYY-MM-DDTHH:mm:ssZ')

          setSurveyCloseDate(formattedDate)
          setCloseDateDialogOpen(false)
          setConfirmLaunchSurveyDialog(true)
          setConfirmLaunchSurveyDialogOpen(true)
        }}
        showCloseDate
      />

      <ConfirmationDialog
        dialogOpen={confirmLaunchSurveyDialog}
        setDialogOpen={setConfirmLaunchSurveyDialog}
        message={t('components.confirmationDialog.launchBeheardSurveyMessage', {
          link: <Link to={ROUTES_PATHS.employees}>{t('linkHere')}</Link>,
        })}
        item={selectedSurvey}
        actionProps={{
          onClick: () => {
            launchSurveyMutation.mutate({
              ...selectedSurvey,
              close_at: surveyCloseDate,
            })
            setConfirmLaunchSurveyDialog(false)
          },
          isLoading: launchSurveyMutation.isLoading,
          label: t('surveyOverview.launchSurvey'),
        }}
      />

      <ConfirmationDialog
        dialogOpen={confirmDeleteDialogOpen}
        setDialogOpen={setConfirmDeleteDialogOpen}
        message={t('components.confirmationDialog.defaultMessage', {
          action: t('components.confirmationDialog.delete'),
          item: selectedSurvey?.name,
        })}
        item={selectedSurvey}
        actionProps={{
          onClick: () => deleteSurveyMutation.mutate(selectedSurvey),
          isLoading: deleteSurveyMutation.isLoading,
          label: t('surveyDialogs.confirmDelete.actionLabel'),
          color: 'error',
        }}
      />

      <SurveyPreviewDialog
        size='lg'
        previewDialog={previewDialog}
        setPreviewDialog={setPreviewDialog}
        headerContent={
          <Alert
            severity='info'
            sx={{ width: '100%' }}
            action={
              <Button
                color='inherit'
                size='small'
                startIcon={<LinkIcon />}
                onClick={() => sharePreviewLinkMutation?.mutate(selectedSurvey)}
                disabled={sharePreviewLinkMutation?.isLoading}
              >
                Copy link
              </Button>
            }
          >
            {'Share this survey preview with stakeholders — no login required, link expires in 5 days.'}
            {previewLinkStatus?.expires_at && ` Current link expires on ${new Date(previewLinkStatus.expires_at).toLocaleDateString()}.`}
          </Alert>
        }
      >
        <Surveys preview={previewDialog?.data} />
      </SurveyPreviewDialog>

      <SurveyReminderNotificationsDialog
        open={reminderNotificationsDialogOpen}
        onClose={() => setReminderNotificationsDialogOpen(false)}
        survey={selectedSurvey}
        surveyType='beheard'
      />
    </>
  )
}
